import React from "react";
import { Box } from "@mui/system";

const DoubleImageBox = (props) => {
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={props.imgSrc} style={{ width: "100%" }} />
    </Box>
  );
};

export default DoubleImageBox;
